import axios from "axios";

function them(dichVu){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/dichvu/them",dichVu);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dichvu/getall");
};
function getDeXuat(dichVu){
  return axios.get(process.env.REACT_APP_URL_SERVER+`/cus/dexuat/getListRecommend/${dichVu}`);
};
function capNhat(dichVu){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/dichvu/capnhat",dichVu);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/dichvu/xoa",ids);
};
function getSoLuongKhachHangSDDichVu(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/dichvu/thongkethiphan");
};
const DichVuService={
  them,
  getAll,
  capNhat,
  xoa,
  getDeXuat,
  getSoLuongKhachHangSDDichVu

};
export default DichVuService;
